import { PageContext } from '@/interfaces/types/PageContext';

export default function ExclusiveBadge(pageContext: PageContext): SiteExclusiveBadge {
    const globalProperties = pageContext?.properties;

    const imageUrl = (globalProperties && globalProperties['exclusive-badge.icon']) || '';
    const image: AEMImage = {
        url: imageUrl,
        altText: '',
        filetype: '',
        format: 'image',
    };

    const background_color = (globalProperties && globalProperties['exclusive-badge.background_color']) || '#0000EB';
    const exclusive_content = (globalProperties && globalProperties['exclusive-badge.content']) || '';
    const aria_label = (globalProperties && globalProperties['exclusive-badge.aria_label']) || '';

    return {
        fields: {
            name: 'Exclusive Content Badge',
            image: image,
            background_color: background_color,
            exclusive_content: exclusive_content,
            aria_label: aria_label,
        },
    };
}
